module.exports = __webpack_public_path__ + "img/honor (4).a404ce6b.jpg";